import React, { Component } from 'react'

export default class PlayerItem extends Component {

    render() {
        
        if (isSmallScreen(this.props.screen)){
            return this.renderSmall();
        }else {
            return this.renderFull();
        }

        
    }

    renderFull(){
        return (
            <div>
               PlayerItem 
            </div>
        ) 
    }
    renderSmall(){
        return (
            <div>
               PlayerItem Small 
            </div>
        )        

    }


}

function isSmallScreen(screen){
    return screen && screen==="700";
}



// WEBPACK FOOTER //
// ./src/Components/Leaderboard/PlayerItem.js